import React from 'react';
import Flex from 'ui/Flex/Flex';

type Props = {
    children: React.ReactNode;
};

const ActionBar = ({ children }: Props) => (
    <Flex justify="space-between" sx={{ mt: '1rem', mb: '2rem' }}>
        {children}
    </Flex>
);

export default ActionBar;
